import SCHEDULE_TYPES from '@constants/scheduleTypes';
import SCHOOL_TYPES from '@constants/schoolTypes';

export interface ILocalCalendarEvent {
    id?:string;
    startDate?:string; // 2023-09-06 09:00:00
    endDate?:string; // 2023-09-06 09:00:00
    title?:string;
    message?:string;
    location?:string;
    calendar?:string;
}

export interface ISchedule {
    id:number;
    status:SCHEDULE_TYPES;
    name?:string;
    school?:SCHOOL_TYPES; // how handovers at school should be labeled, missing = CALCULATED_ON_AGE
    lastHandover:number;
	data: {
        parentA:number;
        parentB:number;
        children:number[];
        scheduleEntriesParentA:{ [key:string]:IScheduleEntry; };
        scheduleEntriesParentB:{ [key:string]:IScheduleEntry; };
    };
}

export interface IScheduleEntry {
    id: number;
    startAtSchool: boolean;
    startTime: number;
    endAtSchool: boolean;
    endTime: number;
    startLoc?: string;
    endLoc?: string;
}

export interface IScheduleName {
    scheduleId:number;
	name: string;
}

export interface IScheduleSchool {
    scheduleId:number;
    school: SCHOOL_TYPES;
}

export enum TemplateName {
    ALTERNATING_WEEKS = "ALTERNATING_WEEKS",
    T3443 = "T3443",
    T223 = "T223",
    T255 = "T2255",
    T3NIGHTSPW = "T3NIGHTSPW",
    T2NIGHTSNPW = "T2NIGHTSNPW",
    T6NIGHTS8NIGHTS = "T6NIGHTS8NIGHTS",
    T5NIGHTS9NIGHTS = "5NIGHTS9NIGHTS",
    T4NIGHTS10NIGHTS = "4NIGHTS10NIGHTS",
    T3NIGHTS11NIGHTS = "T3NIGHTS11NIGHTS",
    T2NIGHTS12NIGHTS = "T2NIGHTS12NIGHTS",
    TDOUBLEWEEK = "TDOUBLEWEEK",
    TTENELEVEN = "TTENELEVEN",
    CUSTOM = "CUSTOM",
  }

export interface IScheduleTemplate {
    days:Array<"A"|"B">;
    title:TemplateName;
    type: 'AlternatingResidence'|'Socializing';
}




// WEBPACK FOOTER //
// ./src/app-types/websocket/schedule.types.ts